import '../../../../vendor/angular-loading-bar/src/loading-bar';

export const loadingBarModule = 'cfp.loadingBarInterceptor';
